import { render, staticRenderFns } from "./picture_cube.vue?vue&type=template&id=5e41ff6d&scoped=true&"
import script from "./picture_cube.vue?vue&type=script&lang=js&"
export * from "./picture_cube.vue?vue&type=script&lang=js&"
import style0 from "./picture_cube.vue?vue&type=style&index=0&id=5e41ff6d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e41ff6d",
  null
  
)

export default component.exports